/* sinob Rezeptseite
   Liest den freien Artikeltext (Zutaten, Zubereitung, Nährwerte, Video, Credits) und baut daraus eine
   strukturierte Rezeptansicht plus schema.org/Recipe. Erkennt alte (2021) und neue (2025/26) Formate.
   Klappt das Parsen nicht (keine Zutaten ODER keine Schritte), bleibt der Originaltext sichtbar. */
(function () {
  'use strict';

  var BLANK = /[ ⠀​‌‍⁠ ﻿]/g;
  var clean = function (s) { return (s || '').replace(BLANK, ' ').replace(/\s+/g, ' ').trim(); };
  var txt = function (el) { return clean(el.textContent); };
  var esc = function (s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); };
  var cap = function (s) { return s ? s.charAt(0).toUpperCase() + s.slice(1) : s; };
  var num = function (s) { return parseFloat(String(s).replace(',', '.')); };
  var MEDIA = 'blockquote.instagram-media,video,iframe';

  var MACROS = [
    ['kcal', /^(kcal|kalorien|energie|brennwert)(?=[\s:=\d~]|$)/i],
    ['protein', /^(e|p|eiweiß|eiweiss|protein|proteine)(?=[\s:=]|$)/i],
    ['carbs', /^(kh|kohlenhydrate|kohlehydrate|carbs)(?=[\s:=]|$)/i],
    ['fat', /^(f|fett|fette)(?=[\s:=]|$)/i],
    ['fiber', /^ballaststoffe(?=[\s:=]|$)/i],
    ['sugar', /^zucker(?=[\s:=]|$)/i]
  ];

  function parseMacro(line) {
    var l = clean(line).replace(/^[-–•·*]\s*/, '').replace(/^davon\s+/i, '');
    for (var i = 0; i < MACROS.length; i++) {
      var m = l.match(MACROS[i][1]);
      if (m) {
        var n = l.slice(m[0].length).match(/(\d+(?:[.,]\d+)?)/);
        if (n) return { key: MACROS[i][0], text: n[1], val: num(n[1]) };
      }
    }
    // Zahl zuerst: "72 kcal", "9,0 g Kohlenhydrate", "95 g Protein"
    var NUM = '(\\d+(?:[.,]\\d+)?)';
    var NF = [
      ['kcal', new RegExp('^' + NUM + '\\s*(?:kcal|kalorien)(?![a-zäöüß])', 'i')],
      ['carbs', new RegExp('^' + NUM + '\\s*g?\\s*(?:kohlenhydrate|kohlehydrate|kh|carbs)(?![a-zäöüß])', 'i')],
      ['protein', new RegExp('^' + NUM + '\\s*g?\\s*(?:eiweiß|eiweiss|proteine?|e|p)(?![a-zäöüß])', 'i')],
      ['fat', new RegExp('^' + NUM + '\\s*g?\\s*(?:fett|fette|f)(?![a-zäöüß])', 'i')],
      ['fiber', new RegExp('^' + NUM + '\\s*g?\\s*ballaststoffe(?![a-zäöüß])', 'i')],
      ['sugar', new RegExp('^' + NUM + '\\s*g?\\s*zucker(?![a-zäöüß])', 'i')]
    ];
    for (var j = 0; j < NF.length; j++) {
      var m2 = l.match(NF[j][1]);
      if (m2) return { key: NF[j][0], text: m2[1], val: num(m2[1]) };
    }
    return null;
  }

  function splitInline(html) {
    // Trennt auch "500kcal, 85g Eiweiß", "Fett,14 g", "159 kcal // 12 g KH" und "KH: 55g Fett: 4g" (Dezimalkomma wie 0,7g bleibt)
    return html.split(/<br\s*\/?>|\||;|\/\/|\s,\s|,\s(?=[A-Za-zÄÖÜäöü])|,\s+(?=\d)|(?<=[A-Za-zäöüß)]),(?=\s*\d)|\s+(?=(?:kh|fett|eiweiß|eiweiss|protein|kohlenhydrate|kohlehydrate|kalorien)\s*:)/i);
  }

  function isEmpty(el) {
    if (el.matches && el.matches(MEDIA)) return false;
    if (el.querySelector && el.querySelector('img,' + MEDIA + ',ul,ol')) return false;
    return txt(el) === '';
  }

  function splitBr(el) {
    return el.innerHTML.split(/<br\s*\/?>|\n/i).map(function (h) { return h.replace(BLANK, ' ').trim(); }).filter(function (h) {
      var d = document.createElement('div'); d.innerHTML = h; return clean(d.textContent) !== '';
    });
  }

  function liHtml(list) {
    return Array.prototype.map.call(list.querySelectorAll(':scope > li'), function (li) { return li.innerHTML.replace(BLANK, ' ').trim(); })
      .filter(function (h) { var d = document.createElement('div'); d.innerHTML = h; return clean(d.textContent) !== ''; });
  }

  function plain(html) { var d = document.createElement('div'); d.innerHTML = html; return clean(d.textContent); }

  function labelOf(el) {
    if (!/^(P|H[1-6]|STRONG|B|SPAN)$/.test(el.tagName)) return null;
    var t = txt(el);
    if (!t) return null;
    if (/^#nutrition/i.test(t)) return { type: 'nutrition', rest: '' };
    if (t.length > 70) return null;
    var strong = el.querySelector('strong,b');
    var labelLike = /^H/.test(el.tagName) || /[:：]$/.test(t) || (strong && txt(strong).length >= t.length - 2) || t.length <= 30 || /^(?:hier die\s+|die\s+)?(?:zutaten|nährwerte?|zub\w{0,10}ung|anleitung)\b/i.test(t);
    if (!labelLike) return null;
    var l = t.replace(/[:：]\s*$/, ''), m;
    if ((m = l.match(/^(?:hier die\s+|die\s+)?zutaten\b\s*(.*)$/i))) return { type: 'ingredients', rest: m[1] };
    if ((m = l.match(/^(?:zub\w{0,10}ung|anleitung)\b\s*(.*)$/i))) return { type: 'steps', rest: m[1] };
    if ((m = l.match(/^(?:die\s+)?nährwerte?\b\s*(.*)$/i))) return { type: 'nutrition', rest: m[1] };
    return null;
  }

  // Bezugsgröße der Nährwerte ("pro Stück: 129", "gesamt", "pro Portion ohne Topping (4 Portionen)")
  function setBasis(d, b) {
    var hint = b.match(/[:：]\s*(\d+(?:[.,]\d+)?)\s*(?:kcal)?\s*$/i);
    if (hint) { d.kcalHint = num(hint[1]); b = b.replace(/[:：]\s*\d+(?:[.,]\d+)?\s*(?:kcal)?\s*$/i, ''); }
    b = b.replace(/[:：]\s*$/, '').trim();
    d.basisKind = /\b(?:gesamt\w*|komplett\w*|insgesamt|total)\b/i.test(b) ? 'total' : (/\b(?:pro|je)\b|portion|stück|stk/i.test(b) ? 'per' : '');
    d.basis = (/^(?:pro|je)\b/i.test(b) || d.basisKind === 'total') ? b : 'pro ' + b;
    d.basis = d.basis.replace(/^(?:pro|je)\s+(?:stück\w*|stk\.?)/i, 'pro Portion');
  }

  function yieldCount(t) {
    if (!t || /\d\s*[-–]\s*\d/.test(t)) return 0;
    var m = t.match(/(\d+(?:[.,]\d+)?)/), n = m ? num(m[1]) : 0;
    return n >= 2 && n <= 100 ? n : 0;
  }

  function fmtNum(v, key) {
    if (key === 'kcal') { var r = Math.round(v); return String(r).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
    return String(Math.round(v * 10) / 10).replace('.', ',');
  }

  // Pro Portion und Gesamt berechnen; erkennt auch gemischte Angaben (z. B. kcal gesamt, Makros pro Stück)
  function normalize(d) {
    var n = yieldCount(d.yieldText), M = d.macros, keys = Object.keys(M);
    if (!n || !keys.length) return;
    var kBasis = '', mBasis = '';
    if (M.kcal && M.protein && M.carbs && M.fat) {
      var kcm = 4 * M.protein.val + 4 * M.carbs.val + 9 * M.fat.val, ratio = kcm > 0 ? M.kcal.val / kcm : 0;
      if (ratio >= 0.7 && ratio <= 1.3) { kBasis = mBasis = d.basisKind; }
      else if (ratio >= 0.7 * n && ratio <= 1.4 * n) { kBasis = 'total'; mBasis = 'per'; }
      else if (ratio > 0 && ratio >= 0.7 / n && ratio <= 1.4 / n) { kBasis = 'per'; mBasis = 'total'; }
    } else { kBasis = mBasis = d.basisKind; }
    if (!kBasis || !mBasis) return;
    var per = {}, total = {}, perNum = {};
    keys.forEach(function (k) {
      var v = M[k], isTotal = (k === 'kcal' ? kBasis : mBasis) === 'total';
      if (isTotal) { total[k] = v.text; per[k] = fmtNum(v.val / n, k); perNum[k] = v.val / n; }
      else { per[k] = v.text; total[k] = fmtNum(v.val * n, k); perNum[k] = v.val; }
    });
    keys.forEach(function (k) { if (k === 'kcal') { if (/^\d{4,}$/.test(per[k])) per[k] = fmtNum(num(per[k]), k); if (/^\d{4,}$/.test(total[k])) total[k] = fmtNum(num(total[k]), k); } });
    d.nutri = { n: n, per: per, total: total, perNum: perNum, mixed: kBasis !== mBasis };
  }


  // Fallback: freie Formulierungen wie "Nährwertangaben für 1 Törtchen bei 6 Törtchen: 159 kcal 15,1g Kohlenhydrate 15g Eiweiß"
  // oder "1 Stk: 91 kcal - 10,9g Eiweiß - 8,2g KH". Greift nur, wenn der normale Weg keine vier Werte gefunden hat.
  var SCAN_KEY = { kcal: 'kcal', kalorien: 'kcal', kh: 'carbs', kohlenhydrate: 'carbs', kohlehydrate: 'carbs', 'eiweiß': 'protein', eiweiss: 'protein', protein: 'protein', proteine: 'protein', p: 'protein', e: 'protein', fett: 'fat', f: 'fat' };
  function scanNutrition(root, d) {
    var have = ['kcal', 'protein', 'carbs', 'fat'].filter(function (k) { return d.macros[k]; }).length;
    if (have >= 4) return;
    var els = root.querySelectorAll('p,div,h1,h2,h3,h4,h5,h6,span,strong');
    var NUM = '(\\d+(?:[.,]\\d+)?)';
    var reNum = new RegExp(NUM + '\\s*(?:g|gr)?\\.?\\s*(kcal|kalorien|kh|kohlenhydrate|kohlehydrate|eiweiß|eiweiss|proteine|protein|fett|p|e|f)(?![a-zäöüß])', 'gi');
    var reLab = new RegExp('(kcal|kalorien|kh|kohlenhydrate|kohlehydrate|eiweiß|eiweiss|proteine|protein|fett)\\s*:?\\s*' + NUM, 'gi');
    var lis = Array.prototype.filter.call(root.querySelectorAll('li'), function (li) { return /^(?:die\s+)?(?:nährwert|naehrwert|kalorien)/i.test(txt(li)); });
    els = Array.prototype.slice.call(els).concat(lis);
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.tagName !== 'LI' && el.closest('li')) continue;
      if (el.querySelector('p,div')) continue;
      var t = txt(el);
      if (!t || t.length > 400 || !/kcal|kalorien|nährwert|naehrwert/i.test(t)) continue;
      // Überschrift wie "Nährwertangaben pro Stück (bei 9 Stück)" mit den Werten in der folgenden Liste
      if (/nährwert|naehrwert/i.test(t) && el.tagName !== 'LI') {
        var sib = el.nextElementSibling;
        while (sib && !txt(sib) && !/^(UL|OL)$/.test(sib.tagName)) sib = sib.nextElementSibling;
        if (!sib && el.parentElement && el.parentElement !== root) { sib = el.parentElement.nextElementSibling; while (sib && !txt(sib) && !/^(UL|OL)$/.test(sib.tagName)) sib = sib.nextElementSibling; }
        if (sib && /^(UL|OL)$/.test(sib.tagName)) t = t + ' ' + Array.prototype.map.call(sib.querySelectorAll('li'), txt).join(', ');
      }
      var cut = t.search(/\bnormale[rn]?\b|zum vergleich/i); if (cut > 0) t = t.slice(0, cut);
      var found = {}, firstPos = -1, m;
      reNum.lastIndex = 0;
      while ((m = reNum.exec(t))) { var k = SCAN_KEY[m[2].toLowerCase()]; if (k && !found[k]) { found[k] = m[1]; if (firstPos < 0 || m.index < firstPos) firstPos = m.index; } }
      reLab.lastIndex = 0;
      while ((m = reLab.exec(t))) { var k2 = SCAN_KEY[m[1].toLowerCase()]; if (k2 && !found[k2]) { found[k2] = m[2]; if (firstPos < 0 || m.index < firstPos) firstPos = m.index; } }
      var keys = Object.keys(found);
      if (keys.length < 2 || keys.length <= have) continue;
      keys.forEach(function (k) { if (!d.macros[k]) d.macros[k] = { key: k, text: found[k], val: num(found[k]) }; });
      var head = firstPos > 0 ? t.slice(0, firstPos) : '';
      if (!d.basisKind) {
        if (/\b(?:pro|je)\b|\b1\s*(?:stk|stück)|für\s+(?:1|ein(?:e|en|em)?)\s|\b1\/\d+|\b1\s+\w+\s+bei\b/i.test(head)) setBasis(d, 'pro Stück');
        else if (/gesamt|insgesamt|für alle|ganze|für\s+(?:[2-9]|\d{2,})\s*\w/i.test(head)) setBasis(d, 'gesamt');
      }
      if (!d.yieldText) {
        var y = head.match(/ergibt\s+(?:insgesamt\s+)?(\d+)\s*([a-zäöüß]+)/i) || head.match(/bei\s+(\d+)\s*([a-zäöüß]+)/i) || head.match(/\b1\/(\d+)\b/) || head.match(/\((\d+)\s*(st(?:ü|u)cke?|stk)/i) || head.match(/für\s+((?:[2-9]|\d{2,}))\s*([a-zäöüß]+)/i);
        if (y) d.yieldText = y[1] + ' ' + (y[2] && !/^st/i.test(y[2]) ? y[2] : 'Stück');
      }
      return;
    }
  }

  function parse(root) {
    var d = { intro: [], groups: [], steps: [], macros: {}, basis: '', yieldText: '', media: [], credits: [], notes: [] };
    var section = 'intro', pending = '', kids = [], introTexts = [], singleGroup = false;

    Array.prototype.forEach.call(root.childNodes, function (n) {
      if (n.nodeType === 1 && n.tagName !== 'META' && n.tagName !== 'BR') kids.push(n);
      else if (n.nodeType === 3 && clean(n.nodeValue)) { var p = document.createElement('p'); p.textContent = n.nodeValue; kids.push(p); }
    });
    kids = kids.reduce(function (acc, k) {
      if (k.tagName === 'P' || k.tagName === 'DIV') {
        var ls = splitBr(k);
        if (ls.length >= 4 && ls.some(function (h) { return /^(?:hier die\s+|die\s+)?(?:zutaten|nährwerte?|zub\w{0,10}ung|anleitung)\b/i.test(plain(h)); })) {
          ls.forEach(function (h) { var np = document.createElement('p'); np.innerHTML = h; acc.push(np); });
          return acc;
        }
      }
      acc.push(k); return acc;
    }, []);
    var hasStepsLabel = kids.some(function (k) { var lb = labelOf(k); return (lb && lb.type === 'steps') || /^(?:zub\w{0,10}ung|anleitung)\s*[:：]/i.test(txt(k)); });
    var nextEl = function (i) { for (var j = i + 1; j < kids.length; j++) if (!isEmpty(kids[j])) return kids[j]; return null; };

    for (var i = 0; i < kids.length; i++) {
      var el = kids[i], tag = el.tagName, t, m;
      if (isEmpty(el)) continue;
      t = txt(el);

      // Medien (#video-Marker wird ignoriert)
      var media = el.matches(MEDIA) ? el : (t.replace(/#video/ig, '').length < 4 ? el.querySelector(MEDIA) : null);
      if (media) { d.media.push(media.outerHTML); continue; }
      if (/^#video\b/i.test(t) && t.length < 12) continue;

      // Credits, Ergibt
      if (t.length < 200 && /rezept/i.test(t) && ((m = t.match(/rezept.*?\svon\s+(@?\S.*?)\s+(?:kre\w*ert|erstellt|entwickelt|zur verfügung gestellt)/i)) || (m = t.match(/rezept.*?(?:kre\w*ert|erstellt|entwickelt|zur verfügung gestellt)\s*von\s*:?\s*(.+)$/i)))) { d.credits.push({ type: 'author', text: m[1].replace(/[.\s]+$/, '') }); continue; }
      if ((m = t.match(/^bild\s*:\s*(https?:\/\/\S+)/i))) { d.credits.push({ type: 'image', url: m[1] }); continue; }
      if ((m = t.match(/^rezept ergibt\s*:?\s*(.*)$/i))) { d.yieldText = m[1]; continue; }
      if (/^(tipp|hinweis|achtung)\b/i.test(t) && t.length < 400) { d.notes.push(el.innerHTML); continue; }

      // Nährwerte inline in einem Absatz: "Nährwerte: Kalorien: 311 , Kohlenhydrate: 58g , Fett: 5g"
      if ((m = t.match(/^(?:die\s+)?nährwerte?\b([^:]{0,40}):\s*(.{8,})$/i)) && /\d/.test(m[2])) {
        var nb = m[1].replace(/^[\/\s-]+/, '').trim(); if (nb) setBasis(d, nb);
        var gotInline = 0;
        splitInline(el.innerHTML.replace(/^[\s\S]*?nährwerte?[^:]*:/i, '')).forEach(function (ln) { var mm = parseMacro(plain(ln)); if (mm) { if (!d.macros[mm.key]) d.macros[mm.key] = mm; gotInline++; } });
        if (gotInline) { section = 'nutrition'; continue; }
      }

      // "Zubereitung: Alles vermengen ..." (Text steht im selben Absatz)
      if (tag === 'P' && (m = t.match(/^(?:zub\w{0,10}ung|anleitung)\s*[:：]\s*(\S.{12,})$/i))) {
        section = 'steps';
        splitBr(el).forEach(function (h, ix) { var hh = ix === 0 ? h.replace(/^[\s\S]*?[:：]\s*(?:<\/\w+>\s*)*/i, '') : h; if (plain(hh)) d.steps.push({ html: hh }); });
        continue;
      }

      // Überschrift am Ende eines Absatzes: "Zimt-Pancakes Zutaten:" / "Pistazien oder nach Wahl Zubereitung:"
      if ((m = t.match(/^(.{2,90}?)\s+zutaten\s*[:：]\s*$/i)) && !/[.!?]$/.test(m[1])) {
        section = 'ingredients'; pending = ''; singleGroup = false; continue;
      }
      if ((m = t.match(/^(.{2,140}?)\s+(?:zub\w{0,10}ung|anleitung)\s*[:：]\s*$/i))) {
        if (section === 'ingredients') { d.groups.push({ title: pending, items: [esc(m[1])] }); pending = ''; }
        section = 'steps'; continue;
      }

      // Abschnittsüberschriften
      var lab = labelOf(el);
      if (lab) {
        // Zweimal "Zubereitung:" hintereinander: die erste Liste waren Zutaten
        if (lab.type === 'steps' && section === 'steps' && !d.groups.length && d.steps.length) {
          var sl = d.steps.filter(function (x) { return x.html; }), sa = sl.reduce(function (a, x) { return a + plain(x.html).length; }, 0) / (sl.length || 1);
          if (sa < 45) { d.groups.push({ title: '', items: sl.map(function (x) { return x.html; }) }); d.steps = []; }
        }
        section = lab.type;
        if (lab.type === 'ingredients') {
          pending = '';
          var r = lab.rest.replace(/^[:：]\s*/, '').replace(/^\(|\)$/g, '').trim();
          if (r && /^(?:[•·\-–]\s*|\d)/.test(r) && !/portion|person|stück|stk/i.test(r.slice(0, 20))) { d.groups.push({ title: '', items: [r.replace(/^(?:[•·\-–]\s*)/, '')] }); singleGroup = true; }
          else if (r && /\d/.test(r) && /portion|person|stück|stk/i.test(r)) { if (!d.yieldText) d.yieldText = r.replace(/^für\s+/i, ''); }
          else pending = cap(r);
        } else if (lab.type === 'nutrition') {
          var b = lab.rest.replace(/^[\/\s-]+/, '');
          if (b) setBasis(d, b);
        }
        continue;
      }

      var isList = tag === 'UL' || tag === 'OL', lines;

      // Erste Liste vor "Zubereitung" ohne Überschrift = Zutaten. Davor stehender Kurztitel liefert ggf. "Ergibt".
      if (isList && section === 'intro' && !d.groups.length && hasStepsLabel) {
        pending = '';
        if (introTexts.length && /[:：]$/.test(introTexts[introTexts.length - 1]) && introTexts[introTexts.length - 1].length <= 45) {
          pending = cap(introTexts[introTexts.length - 1].replace(/[:：]\s*$/, '')); d.intro.pop(); introTexts.pop();
        } else if (introTexts.length && introTexts[introTexts.length - 1].length <= 90) {
          var tt = introTexts[introTexts.length - 1], br = tt.match(/\(([^)]*)\)/);
          if (br) { var seg = br[1].split(',').map(function (x) { return x.trim(); }).filter(function (x) { return /\d/.test(x) && /stück|stk|portion|person|brötchen|muffin|donut|cookie|scheibe/i.test(x); })[0]; if (seg && !d.yieldText) d.yieldText = seg; }
          d.intro.pop(); introTexts.pop();
        }
        section = 'ingredients';
      }

      if (section === 'ingredients') {
        if (isList) {
          var its = liHtml(el), avg = its.length ? its.map(function (x) { return plain(x).length; }).reduce(function (a, b) { return a + b; }, 0) / its.length : 0;
          var dots = its.filter(function (x) { return /[.!]\s*$/.test(plain(x)); }).length;
          if (d.groups.length && !d.steps.length && (avg > 60 || (its.length && dots / its.length >= 0.6 && avg > 30))) { section = 'steps'; its.forEach(function (h) { d.steps.push({ html: h }); }); continue; }
          d.groups.push({ title: pending, items: its }); pending = ''; singleGroup = false; continue;
        }
        var nx = nextEl(i);
        lines = splitBr(el);
        if (lines.length > 1) { d.groups.push({ title: pending, items: lines.map(function (h) { return h.replace(/^(?:[•·\-–]\s*)/, ''); }) }); pending = ''; singleGroup = false; continue; }
        if (t.length <= 45 && ((nx && (nx.tagName === 'UL' || nx.tagName === 'OL')) || /[:：]$/.test(t))) { pending = cap(t.replace(/[:：]\s*$/, '')); continue; }
        if (lines.length === 1 && t.length <= 120 && (tag === 'A' || /^(?:[•·\-–]\s*)?(?:[\d½¼¾⅓⅔]|ca\.?\s|etwas\b|eine?\b|prise\b|nach\b|optional)/i.test(t))) {
          var item = lines[0].replace(/^(?:[•·\-–]\s*)/, '');
          if (singleGroup && !pending && d.groups.length) d.groups[d.groups.length - 1].items.push(item);
          else { d.groups.push({ title: pending, items: [item] }); singleGroup = true; }
          pending = ''; continue;
        }
        d.notes.push(el.outerHTML); continue;
      }

      if (section === 'steps') {
        if (isList) { liHtml(el).forEach(function (h) { d.steps.push({ html: h }); }); continue; }
        lines = splitBr(el);
        if (lines.length === 1 && /[:：]$/.test(t) && t.length <= 45) d.steps.push({ h: t.replace(/[:：]\s*$/, '') });
        else lines.forEach(function (h) { d.steps.push({ html: h }); });
        continue;
      }

      if (section === 'nutrition') {
        var got = 0, parts = isList ? liHtml(el).map(plain) : splitInline(el.innerHTML).map(plain);
        parts.forEach(function (ln) { var mm = parseMacro(ln); if (mm) { if (!d.macros[mm.key]) d.macros[mm.key] = mm; got++; } });
        if (got) continue;
        section = 'other';
      }

      if (section === 'intro') { d.intro.push(el.outerHTML); introTexts.push(t); } else d.notes.push(el.outerHTML);
    }
    if (d.intro.length === 1 && introTexts.length === 1 && introTexts[0].length <= 70 && !/[.!?]$/.test(introTexts[0])) d.intro = [];
    try { scanNutrition(root, d); } catch (e) { /* Fallback darf nichts kaputt machen */ }
    normalize(d);
    return d;
  }

  /* ---------- Rendering ---------- */

  function linkify(el) {
    var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null), nodes = [], n;
    while ((n = w.nextNode())) if (!n.parentNode.closest('a') && /https?:\/\//.test(n.nodeValue)) nodes.push(n);
    nodes.forEach(function (node) {
      var s = document.createElement('span');
      s.innerHTML = esc(node.nodeValue).replace(/(https?:\/\/[^\s<]+)/g, '<a href="$1" target="_blank" rel="noopener">$1</a>');
      node.parentNode.replaceChild(s, node);
    });
  }

  function markProductLinks(html) {
    var d = document.createElement('div'); d.innerHTML = html;
    Array.prototype.forEach.call(d.querySelectorAll('a'), function (a) {
      if (/sinob\.de|^\//.test(a.getAttribute('href') || '')) a.classList.add('recipe__link--product');
      else { a.target = '_blank'; a.rel = 'noopener'; }
    });
    return d.innerHTML;
  }

  // Prozentwerte, die sich garantiert zu 100 summieren (Größte-Reste-Verfahren)
  function shares(vals) {
    var tot = vals.reduce(function (a, b) { return a + b; }, 0), raw = vals.map(function (v) { return v / tot * 100; });
    var out = raw.map(Math.floor), left = 100 - out.reduce(function (a, b) { return a + b; }, 0);
    raw.map(function (v, i) { return [v - Math.floor(v), i]; }).sort(function (x, y) { return y[0] - x[0]; }).slice(0, left).forEach(function (r) { out[r[1]]++; });
    return out;
  }

  function toggleHtml(cls) {
    return '<div class="recipe__toggle ' + (cls || '') + '" role="group" aria-label="Nährwerte anzeigen für">' +
      '<button type="button" class="recipe__toggle-btn is-active" data-mode="per" aria-pressed="true">Pro Portion</button>' +
      '<button type="button" class="recipe__toggle-btn" data-mode="total" aria-pressed="false">Gesamt</button></div>';
  }

  function basisLabels(d) {
    var n = d.nutri.n, b = d.basis || '', q = b.replace(/^(?:pro|je)\s+(?:stück\w*|stk\.?|portion\w*)\s*/i, '');
    var per = (d.basisKind === 'per' && b) ? (/^(?:pro|je)\s+(?:stück\w*|stk\.?|portion\w*)/i.test(b) ? 'pro Portion' + (q ? ' ' + q : '') : b) : 'pro Portion';
    var tot = 'gesamt' + (d.basisKind === 'per' && q && q !== b ? ' ' + q : ' (' + n + ' Portionen)');
    return [cap(per), cap(tot)];
  }

  function macroCards(d) {
    var M = d.macros, N = d.nutri, defs = [['kcal', 'Kalorien', 'kcal'], ['protein', 'Protein', 'g'], ['carbs', 'Kohlenhydrate', 'g'], ['fat', 'Fett', 'g']];
    var cards = defs.filter(function (x) { return M[x[0]]; }).map(function (x) {
      var val = N ? '<span class="recipe__macro-val" data-nv-per="' + esc(N.per[x[0]]) + '" data-nv-total="' + esc(N.total[x[0]]) + '">' + esc(N.per[x[0]]) + '</span>' : '<span class="recipe__macro-val">' + esc(M[x[0]].text) + '</span>';
      return '<div class="recipe__macro' + (x[0] === 'protein' ? ' recipe__macro--protein' : '') + '"><span class="recipe__macro-num">' + val +
        '<span class="recipe__macro-unit">' + x[2] + '</span></span><span class="recipe__macro-label">' + x[1] + '</span></div>';
    }).join('');
    if (!cards) return '';
    var sub = '';
    var sv = function (k) { return N ? '<span data-nv-per="' + esc(N.per[k]) + '" data-nv-total="' + esc(N.total[k]) + '">' + esc(N.per[k]) + '</span>' : esc(M[k].text); };
    if (M.fiber) sub += 'Ballaststoffe ' + sv('fiber') + ' g';
    if (M.sugar) sub += (sub ? ' · ' : '') + 'davon Zucker ' + sv('sugar') + ' g';
    var bar = '';
    if (M.protein && M.carbs && M.fat) {
      var pv = N ? N.perNum : { protein: M.protein.val, carbs: M.carbs.val, fat: M.fat.val };
      var kc = [pv.protein * 4, pv.carbs * 4, pv.fat * 9];
      if (kc[0] + kc[1] + kc[2] > 0) {
        var sh = shares(kc);
        bar = '<div class="recipe__split-wrap"><p class="recipe__split-title">Woher die Kalorien kommen</p>' +
          '<div class="recipe__split" role="img" aria-label="Kalorienverteilung: Protein ' + sh[0] + ' %, Kohlenhydrate ' + sh[1] + ' %, Fett ' + sh[2] + ' %">' +
          [['p', sh[0]], ['c', sh[1]], ['f', sh[2]]].filter(function (x) { return x[1] > 0; }).map(function (x) { return '<span class="recipe__split-' + x[0] + '" style="flex:' + x[1] + ' 1 0"></span>'; }).join('') + '</div>' +
          '<ul class="recipe__legend"><li><i class="recipe__dot recipe__dot--p"></i>Protein <b>' + sh[0] + ' %</b></li><li><i class="recipe__dot recipe__dot--c"></i>Kohlenhydrate <b>' + sh[1] + ' %</b></li><li><i class="recipe__dot recipe__dot--f"></i>Fett <b>' + sh[2] + ' %</b></li></ul></div>';
      }
    }
    var basis = '', head = '<h2 class="recipe__h">Nährwerte</h2>', note = 'Richtwerte laut Rezept. Prozentwerte aus Protein, Kohlenhydraten und Fett berechnet, je nach Zutaten und Marken kann es abweichen.';
    if (N) {
      var bl = basisLabels(d);
      basis = '<p class="recipe__basis" data-nv-per="' + esc(bl[0]) + '" data-nv-total="' + esc(bl[1]) + '">' + esc(bl[0]) + '</p>';
      head = '<div class="recipe__nutri-head">' + head + toggleHtml('') + '</div>';
      note = 'Richtwerte laut Rezept (' + N.n + ' Portionen). Die jeweils andere Ansicht ist berechnet. Prozentwerte aus Protein, Kohlenhydraten und Fett berechnet, je nach Zutaten und Marken kann es abweichen.';
    } else if (d.basis) basis = '<p class="recipe__basis">' + esc(cap(d.basis)) + '</p>';
    return '<section class="recipe__nutrition">' + head + basis + '<div class="recipe__macros">' + cards + '</div>' +
      (sub ? '<p class="recipe__sub-macros">' + sub + '</p>' : '') + bar + '<p class="recipe__note">' + note + '</p></section>';
  }

  function render(d) {
    var h = '<div class="recipe__layout"><aside class="recipe__col recipe__col--ing"><div class="recipe__card"><h2 class="recipe__h">Zutaten</h2>';
    if (d.yieldText) h += '<p class="recipe__yield">Ergibt: ' + esc(d.yieldText) + '</p>';
    d.groups.forEach(function (g) {
      if (g.title) h += '<h3 class="recipe__sub">' + esc(g.title) + '</h3>';
      h += '<ul class="recipe__ingredients">' + g.items.map(function (it) {
        return '<li><label class="recipe__ing"><input type="checkbox" class="recipe__cb"><span class="recipe__box" aria-hidden="true"></span><span class="recipe__ing-text">' + markProductLinks(it) + '</span></label></li>';
      }).join('') + '</ul>';
    });
    h += '<p class="recipe__hint">Antippen zum Abhaken.</p></div></aside><div class="recipe__col recipe__col--steps">';
    if (d.intro.length) h += '<div class="recipe__intro">' + d.intro.join('') + '</div>';
    if (d.steps.length) h += '<h2 class="recipe__h">Zubereitung</h2><ol class="recipe__steps">' + d.steps.map(function (s) {
      return s.h ? '<li class="recipe__step-heading">' + esc(s.h) + '</li>' : '<li class="recipe__step"><div class="recipe__step-text">' + markProductLinks(s.html) + '</div></li>';
    }).join('') + '</ol>';
    if (d.media.length) h += '<details class="recipe__video"><summary class="recipe__video-sum"><span>Video zum Rezept ansehen</span><svg class="recipe__video-icon" width="18" height="10" viewBox="0 0 18 10" fill="none" aria-hidden="true"><path d="M1.06 .92l8 8 8-8" stroke="currentColor" stroke-width="1.5"/></svg></summary><div class="recipe__video-body">' + d.media.join('') + '</div></details>';
    if (d.notes.length) h += '<div class="recipe__notes">' + d.notes.map(function (n) { return '<div class="recipe__note-item">' + n + '</div>'; }).join('') + '</div>';
    if (d.credits.length) {
      h += '<p class="recipe__credits">' + d.credits.map(function (c) {
        if (c.type === 'image') return 'Bild: <a href="' + esc(c.url) + '" target="_blank" rel="noopener">Quelle</a>';
        var hd = c.text.match(/@([A-Za-z0-9._]*[A-Za-z0-9_])/);
        return 'Rezept von ' + (hd ? '<a href="https://www.instagram.com/' + esc(hd[1]) + '/" target="_blank" rel="noopener">@' + esc(hd[1]) + '</a>' : esc(c.text));
      }).join(' · ') + '</p>';
    }
    h += '</div></div>' + macroCards(d);
    return h;
  }

  function addFacts(host, d) {
    var box = host.querySelector('[data-recipe-facts]');
    if (!box) return;
    var items = [];
    if (d.yieldText) items.push(['Ergibt', d.yieldText, '']);
    var N = d.nutri, bl = N ? basisLabels(d) : null;
    var attrs = function (a, b) { return (a === undefined || b === undefined) ? '' : ' data-nv-per="' + esc(a) + '" data-nv-total="' + esc(b) + '"'; };
    if (d.macros.kcal) items.push(N ? ['Kalorien', N.per.kcal + ' kcal', bl[0], '', N.total.kcal + ' kcal', bl[1]] : ['Kalorien', d.macros.kcal.text + ' kcal', d.basis]);
    if (d.macros.protein) items.push(N ? ['Protein', N.per.protein + ' g', bl[0], 'protein', N.total.protein + ' g', bl[1]] : ['Protein', d.macros.protein.text + ' g', d.basis, 'protein']);
    items.forEach(function (f) {
      var e = document.createElement('div');
      e.className = 'recipe__fact' + (f[3] ? ' recipe__fact--' + f[3] : '');
      e.innerHTML = '<span class="recipe__fact-label">' + esc(f[0]) + '</span><span class="recipe__fact-val"' + attrs(f[1], f[4]) + '>' + esc(f[1]) + '</span>' + (f[2] ? '<span class="recipe__fact-sub"' + attrs(f[2], f[5]) + '>' + esc(cap(f[2])) + '</span>' : '');
      box.appendChild(e);
    });
    if (N) { var row = document.createElement('div'); row.className = 'recipe__toggle-row'; row.innerHTML = toggleHtml('recipe__toggle--hero'); box.appendChild(row); }
  }

  function isoDuration(s) {
    var h = (s || '').match(/(\d+)\s*(?:h|std)/i), m = (s || '').match(/(\d+)\s*min/i);
    if (!h && !m) return '';
    return 'PT' + (h ? h[1] + 'H' : '') + (m ? m[1] + 'M' : '');
  }

  function jsonLd(host, d) {
    var data = host.dataset, meta = document.querySelector('meta[name="description"]');
    var ld = {
      '@context': 'https://schema.org', '@type': 'Recipe', name: data.title || document.title,
      author: { '@type': 'Organization', name: 'sinob' },
      recipeIngredient: d.groups.reduce(function (a, g) { return a.concat(g.items.map(plain)); }, []),
      recipeInstructions: d.steps.filter(function (s) { return s.html; }).map(function (s) { return { '@type': 'HowToStep', text: plain(s.html) }; })
    };
    if (data.image) ld.image = [data.image];
    if (data.published) ld.datePublished = data.published;
    if (meta && meta.content) ld.description = meta.content;
    if (d.yieldText) ld.recipeYield = d.yieldText;
    var iso = isoDuration(data.time); if (iso) ld.totalTime = iso;
    var M = d.macros, nut = { '@type': 'NutritionInformation' }, any = false, N = d.nutri, T = function (k) { return N ? N.per[k] : M[k].text; };
    if (M.kcal) { nut.calories = T('kcal') + ' kcal'; any = true; }
    if (M.protein) { nut.proteinContent = T('protein') + ' g'; any = true; }
    if (M.carbs) { nut.carbohydrateContent = T('carbs') + ' g'; any = true; }
    if (M.fat) { nut.fatContent = T('fat') + ' g'; any = true; }
    if (M.fiber) nut.fiberContent = T('fiber') + ' g';
    if (M.sugar) nut.sugarContent = T('sugar') + ' g';
    if (any) { if (N) nut.servingSize = '1 Portion'; else if (d.basisKind === 'per') nut.servingSize = '1 Portion'; ld.nutrition = nut; }
    var s = document.createElement('script');
    s.type = 'application/ld+json'; s.text = JSON.stringify(ld);
    document.head.appendChild(s);
  }

  function loadInsta() {
    if (window.instgrm && window.instgrm.Embeds) { window.instgrm.Embeds.process(); return; }
    var sc = document.createElement('script'); sc.async = true; sc.src = 'https://www.instagram.com/embed.js'; document.body.appendChild(sc);
  }

  function init() {
    var host = document.querySelector('[data-recipe]');
    if (!host) return;
    var src = host.querySelector('[data-recipe-source]'), target = host.querySelector('[data-recipe-target]');
    if (!src || !target) return;
    var d;
    try { d = parse(src); } catch (e) { return; }
    // Fallback aus Metafeldern (custom.portionen / custom.naehrwert_bezug), wenn der Text nichts dazu sagt
    try {
      var fb = false;
      if (!d.yieldText && host.dataset.yield) { d.yieldText = host.dataset.yield; fb = true; }
      if (!d.basisKind && host.dataset.basis) { setBasis(d, host.dataset.basis); fb = true; }
      if (fb) normalize(d);
    } catch (e) { /* Fallback darf die Seite nicht stören */ }
    if (!d.groups.length) { host.classList.add('recipe--raw'); if (src.querySelector('blockquote.instagram-media')) loadInsta(); return; }
    target.innerHTML = render(d);
    Array.prototype.forEach.call(target.querySelectorAll('.recipe__notes,.recipe__intro'), linkify);
    addFacts(host, d);
    host.addEventListener('click', function (ev) {
      var b = ev.target.closest && ev.target.closest('.recipe__toggle-btn'); if (!b) return;
      var mode = b.getAttribute('data-mode') === 'total' ? 'total' : 'per';
      Array.prototype.forEach.call(host.querySelectorAll('[data-nv-per]'), function (el) { el.textContent = el.getAttribute('data-nv-' + mode); });
      Array.prototype.forEach.call(host.querySelectorAll('.recipe__toggle-btn'), function (x) { var on = x.getAttribute('data-mode') === mode; x.classList.toggle('is-active', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    });
    src.hidden = true; target.hidden = false; host.classList.add('recipe--ready');
    try { jsonLd(host, d); } catch (e) { /* SEO-Zusatz, darf die Seite nicht stören */ }
    // Video erst beim Aufklappen laden (Instagram-Embed ist hoch und ein Drittanbieter-Script)
    var vid = target.querySelector('.recipe__video');
    if (vid) vid.addEventListener('toggle', function () {
      if (!vid.open || vid.dataset.loaded || !vid.querySelector('blockquote.instagram-media')) return;
      vid.dataset.loaded = '1';
      loadInsta();
    });
  }

  window.SinobRecipe = { parse: parse };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
